import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Contact() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="contact" ref={ref} className="py-24 md:py-32 bg-gradient-to-b from-white to-warm-ivory">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <div className={`grid grid-cols-1 lg:grid-cols-5 overflow-hidden ring-1 ring-gold-300/50 shadow-[0_8px_32px_rgba(139,90,43,0.08)] ${isVisible ? 'reveal revealed' : 'reveal'}`}>
          {/* Left panel */}
          <div className="lg:col-span-3 bg-gradient-to-br from-champagne-50 via-champagne-100/50 to-warm-ivory p-10 md:p-14 flex flex-col justify-center">
            <p className="text-[10px] tracking-[0.3em] text-gold-500 uppercase mb-5 font-medium">お問い合わせ</p>
            <h2 className="font-heading text-4xl md:text-5xl font-semibold text-charcoal-800 tracking-tight mb-6">
              お問い合わせ
            </h2>
            <p className="text-sm md:text-base text-charcoal-400 leading-[1.9] max-w-sm font-light">
              楽曲制作のご依頼、コラボレーションのご提案など、お気軽にお問い合わせください。ご連絡をお待ちしています。
            </p>
          </div>

          {/* Right panel */}
          <div className="lg:col-span-2 bg-white p-10 md:p-14 flex flex-col justify-center">
            <a
              href="mailto:andmay.ameriria@gmail.com"
              className="group flex items-center justify-between px-8 py-6 bg-gradient-to-r from-gold-500 to-gold-400 text-white whitespace-nowrap cursor-pointer transition-all duration-300 hover:from-gold-600 hover:to-gold-500 shadow-[0_4px_20px_rgba(139,90,43,0.25)] hover:shadow-[0_6px_28px_rgba(139,90,43,0.35)] hover:-translate-y-0.5"
            >
              <span className="flex items-center gap-3">
                <i className="ri-mail-send-fill text-xl"></i>
                <span className="text-sm font-bold tracking-widest">メールで送信</span>
              </span>
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform duration-300"></i>
            </a>

            <div className="pt-5 mt-5 border-t border-champagne-200">
              <p className="text-xs text-charcoal-400 flex items-center gap-2 font-light">
                <i className="ri-mail-line text-gold-400"></i>
                andmay.ameriria@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}